// Port of api/fuel/app/classes/insights/members/divisive.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Rating from 'offline/model/rating'
import Util from 'offline/util'

function membersDivisiveAnalysis(owner, userIndex) {
	if (userIndex.length < 2) return []

	var games = {}
	var threshold = owner.get_threshold()
	var ratings = Rating.filter({
		arrayed: true,
		select: {
			plain: ['user_id', 'game_id', 'rating_value']
		},
		where: [
			['user_id', 'in', userIndex]
		],
		order_by: 'rating_value ASC'
	})

	for (var i = 0; i < ratings.length; i++) {
		var rating = ratings[i]
		var gameId = parseInt(rating.game_id, 10)
		if (!games[gameId]) {
			games[gameId] = {
				id: gameId,
				userRatings: {},
				ratings: [],
				median: 0,
				diff: 0
			}
		}
		games[gameId].userRatings[parseInt(rating.user_id, 10)] = parseFloat(rating.rating_value)
		games[gameId].ratings.push(parseFloat(rating.rating_value))
	}

	var result = Object.keys(games).map(function(key) { return games[key] })
	for (var g = 0; g < result.length; g++) {
		var ratingCount = result[g].ratings.length
		var midPoint = Math.floor(ratingCount / 2)
		if (ratingCount % 2 === 0) result[g].median = (result[g].ratings[midPoint] + result[g].ratings[midPoint - 1]) / 2
		else result[g].median = result[g].ratings[midPoint]

		for (var r = 0; r < result[g].ratings.length; r++) result[g].diff += Math.abs(result[g].ratings[r] - result[g].median)
		result[g].diff = result[g].diff / ratingCount
	}

	// PHP path excludes low-sample games by group threshold.
	return result.filter(function(item) {
		return item.ratings.length >= threshold
	})
}

function membersDivisivePackage(segment, divisive, detail, compareType) {
	var limit = detail ? 100 : 5
	var sorted = Util.sort_by_field(divisive, 'diff', compareType === 'most' ? 'desc' : 'asc').filter(function(item) {
		return compareType === 'most' ? item.diff > 1 : item.diff < 1
	}).slice(0, limit)

	for (var i = 0; i < sorted.length; i++) {
		var gameAverage = sorted[i].ratings.length ? (sorted[i].ratings.reduce(function(a, b) { return a + b }, 0) / sorted[i].ratings.length) : 0
		sorted[i].count = sorted[i].ratings.length
		sorted[i].rating = Math.round(gameAverage * 10) / 10

		var userIds = Object.keys(sorted[i].userRatings)
		if (userIds.length > 6) {
			var userRatings = []
			for (var u = 0; u < userIds.length; u++) {
				userRatings.push({ id: parseInt(userIds[u], 10), rating: sorted[i].userRatings[userIds[u]] })
			}
			userRatings.sort(function(a, b) { return a.rating - b.rating })
			var sample = userRatings.slice(0, 3).concat(userRatings.slice(-3))
			var sampledMap = {}
			for (var s = 0; s < sample.length; s++) {
				sampledMap[sample[s].id] = sample[s].rating
				segment._references.users.push(sample[s].id)
			}
			sorted[i].userRatings = sampledMap
		} else {
			for (var ur = 0; ur < userIds.length; ur++) segment._references.users.push(parseInt(userIds[ur], 10))
		}

		segment._references.games.push(parseInt(sorted[i].id, 10))
	}

	return sorted
}

export default Segment.extend({
	name: 'divisive',
	types: [Constants.TYPE_GROUP],
	insight: false,
	detail: ['divisive'],
	run: function(type, owner, userIndex, detail, filter, vars) {
		var members = membersDivisiveAnalysis(owner, userIndex)

		if (detail) {
			return {
				divisive: membersDivisivePackage(this, members, detail, vars.compareType)
			}
		}

		return {
			divisive: {
				most: membersDivisivePackage(this, members, detail, 'most'),
				least: membersDivisivePackage(this, members, detail, 'least')
			}
		}
	}
})
